export const EMPTY_ARRAY = Object.freeze([]) satisfies readonly unknown[]

/**
 * Represents an empty object and nothing else.
 * Because the type `{}` is unreliable in TypeScript and should not be used.
 *
 * @source https://github.com/sindresorhus/type-fest/blob/main/source/empty-object.d.ts
 */
export type EmptyObject = { [emptyObjectSymbol]?: never }

declare const emptyObjectSymbol: unique symbol

// Object entry helpers
type ValueOf<T> = T[keyof T]
type ObjectEntries<T> = [keyof T, ValueOf<T>][]

/**
 * Same as `Object.entries()` but with type inference
 *
 * @see {@link https://stackoverflow.com/a/75337277}
 */
export function objectEntries<T extends object>(obj: T): ObjectEntries<T> {
  return Object.entries(obj) as ObjectEntries<T>
}

/**
 * Runtime check whether a value matches an Enum (or fake Enum).
 *
 * Note: should only be used with String Enums and Objects, not Numeric Enums!
 */
export function isValueInEnum(value: unknown, enumObj: object): boolean {
  return Object.values(enumObj).includes(value)
}
